export default __webpack_public_path__ + "static/media/createimpact.22d990ca.webp";